import type { MatchResultDto, RoomType } from '@chromarble/shared-types';

export interface InviteMessageInput {
  roomTitle: string;
  roomType: RoomType;
  memberCount: number;
  maxPlayers: number;
  durationSec: number;
  url: string;
}

export interface ShareMessage {
  title: string;
  text: string;
}

export function roomTypeLabel(type: RoomType): string {
  return type === 'LUNCH_BET' ? '점심내기' : '일반 친선대전';
}

export function buildInviteMessage(input: InviteMessageInput): ShareMessage {
  const title = input.roomType === 'LUNCH_BET' ? '크로마블 점심내기 대전' : '크로마블 친선 대전';
  const rule = input.roomType === 'LUNCH_BET' ? '최하위 점심결제 (최하위 동점 시 재대전)' : '점수 순위 경쟁';
  const lines = [
    title,
    `방 이름: ${input.roomTitle}`,
    `- 경기: ${input.durationSec}초`,
    `- 참가 인원: ${input.memberCount}/${input.maxPlayers}명`,
    `- 방식: ${roomTypeLabel(input.roomType)}`,
    `- 룰: ${rule}`,
    `- 참가: ${input.url}`,
    '(같은 Crew 구성원만 참가할 수 있으며 링크는 방 만료 시 사용할 수 없습니다.)',
  ];
  return { title, text: lines.join('\n') };
}

export function formatScore(score: number): string {
  return score.toLocaleString('ko-KR');
}

export function buildResultMessage(result: MatchResultDto, rematchUrl: string | null): ShareMessage {
  const title = '크로마블 대전 결과';
  const nick = new Map(result.standings.map((s) => [s.userId, s.nickname]));
  const lines = [title, ''];
  for (const s of result.standings) {
    const tag = s.finishStatus === 'FORFEITED' ? ' (기권)' : '';
    lines.push(`${s.finalRank}위 ${s.nickname} — ${formatScore(s.finalScore)}점${tag}`);
  }
  lines.push('');
  if (result.winnerIds.length === 0) {
    lines.push('우승자: 없음');
  } else if (result.coWinners) {
    lines.push(`공동 우승: ${result.winnerIds.map((id) => nick.get(id) ?? '?').join(', ')}`);
  } else {
    lines.push(`우승자: ${nick.get(result.winnerIds[0]!) ?? '?'}`);
  }
  if (result.lunch) {
    if (result.lunch.payerUserId) {
      lines.push(`점심내기 결과: ${nick.get(result.lunch.payerUserId) ?? '?'}`);
    } else if (result.lunch.tie) {
      lines.push(`점심내기 결과: 최하위 동점 (${result.lunch.tiedUserIds.map((id) => nick.get(id) ?? '?').join(', ')}) — 재대전으로 결정`);
    }
    lines.push('※ 실제 결제는 게임에서 처리하지 않습니다.');
  }
  if (rematchUrl) {
    lines.push('');
    lines.push(`재대전 참가: ${rematchUrl}`);
  }
  return { title, text: lines.join('\n') };
}
